import React from "react";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Link from "next/link";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import Image from "next/image";
import I1 from "@/public/static/images/instrument/in-1.png";
import I2 from "@/public/static/images/instrument/in-2.png";
import I3 from "@/public/static/images/instrument/in-3.png";
import I4 from "@/public/static/images/instrument/in-4.png";
import I5 from "@/public/static/images/instrument/in-5.png";
import I6 from "@/public/static/images/instrument/in-6.png";
import I7 from "@/public/static/images/instrument/in-7.png";
import I8 from "@/public/static/images/instrument/in-8.png";
import I9 from "@/public/static/images/instrument/in-9.png";
import I10 from "@/public/static/images/instrument/in-10.png";

function ListImage() {
  return (
    <div className="row">
      <Grid
        container
        spacing={{ xs: 2, md: 3 }}
        columns={{ xs: 12, sm: 12, md: 12 }}
      >
        <Grid item xs={12} sm={6} md={4} sx={{ mb: 3 }}>
          <Card className="card-list-instru h-100">
            <div className="list-instru_inner">
              <Image
                loading="lazy"
                src={I1}
                alt="ゼニヤタイランド"
                className="card-img"
                width={300}
              />
            </div>
            <CardContent className="list-instru-text">
              <Typography gutterBottom component="h5">
                250トン　トランスファープレス
              </Typography>
              <div>
                <ul>
                  <li>タイでは少ないとされるクラスのトン数設備を保有</li>
                </ul>
              </div>
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={12} sm={6} md={4} sx={{ mb: 3 }}>
          <Card className="card-list-instru h-100">
            <div className="list-instru_inner">
              <Image
                loading="lazy"
                src={I2}
                alt="ゼニヤタイランド"
                className="card-img"
                width={300}
              />
            </div>
            <CardContent className="list-instru-text">
              <Typography gutterBottom component="h5">
                150トン　自動搬送プレス
              </Typography>
              <div>
                <ul>
                  <li>自動化によりコスト削減</li>
                </ul>
              </div>
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={12} sm={6} md={4} sx={{ mb: 3 }}>
          <Card className="card-list-instru h-100">
            <div className="list-instru_inner">
              <Image
                loading="lazy"
                src={I3}
                alt="ゼニヤタイランド"
                className="card-img"
                width={300}
              />
            </div>
            <CardContent className="list-instru-text">
              <Typography gutterBottom component="h5">
                マシニング(ミリング、異形切削)
              </Typography>
              <div>
                <ul>
                  <li>空調管理された部屋に設置し高精度異形切削</li>
                </ul>
              </div>
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={12} sm={6} md={4} sx={{ mb: 3 }}>
          <Card className="card-list-instru h-100">
            <div className="list-instru_inner">
              <Image
                loading="lazy"
                src={I4}
                alt="ゼニヤタイランド"
                className="card-img"
                width={300}
              />
            </div>
            <CardContent className="list-instru-text">
              <Typography gutterBottom component="h5">
                エアーブラスト機
              </Typography>
              <div>
                <ul>
                  <li>梨地処理</li>
                </ul>
              </div>
            </CardContent>
          </Card>
        </Grid>
        {/* <Grid item xs={12} sm={6} md={4} sx={{ mb: 3 }}>
          <Card className="card-list-instru h-100">
            <div className="list-instru_inner">
              <Image
                loading="lazy"
                src={I5}
                alt="ゼニヤタイランド"
                className="card-img"
                width={300}
              />
            </div>
            <CardContent className="list-instru-text">
              <Typography gutterBottom component="h5">
                大型複合旋盤
              </Typography>
            </CardContent>
          </Card>
        </Grid> */}
        <Grid item xs={12} sm={6} md={4} sx={{ mb: 3 }}>
          <Card className="card-list-instru h-100">
            <div className="list-instru_inner">
              <Image
                loading="lazy"
                src={I6}
                alt="ゼニヤタイランド"
                className="card-img"
                width={300}
              />
            </div>
            <CardContent className="list-instru-text">
              <Typography gutterBottom component="h5">
                金型・治具各種加工設備
              </Typography>
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={12} sm={6} md={4} sx={{ mb: 3 }}>
          <Card className="card-list-instru h-100">
            <div className="list-instru_inner">
              <Image
                loading="lazy"
                src={I7}
                alt="ゼニヤタイランド"
                className="card-img"
                width={300}
              />
            </div>
            <CardContent className="list-instru-text">
              <Typography gutterBottom component="h5">
                アルマイト量産ライン　2ライン
              </Typography>
              <div>
                <ul>
                  <li>各ラインに着色槽、化学研磨槽を保有</li>
                  <li>通常無色・着色アルマイト加工に対応</li>
                  <li>製品サイズ最大 1,200mm x 900mm に対応</li>
                </ul>
              </div>
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={12} sm={6} md={4} sx={{ mb: 3 }}>
          <Card className="card-list-instru h-100">
            <div className="list-instru_inner">
              <Image
                loading="lazy"
                src={I8}
                alt="ゼニヤタイランド"
                className="card-img"
                width={300}
              />
            </div>
            <CardContent className="list-instru-text">
              <Typography gutterBottom component="h5">
                アルマイト小型製品量産・試作ライン
              </Typography>
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={12} sm={6} md={4} sx={{ mb: 3 }}>
          <Card className="card-list-instru h-100">
            <div className="list-instru_inner">
              <Image
                loading="lazy"
                src={I9}
                alt="ゼニヤタイランド"
                className="card-img"
                width={300}
              />
            </div>
            <CardContent className="list-instru-text">
              <Typography gutterBottom component="h5">
                三次元測定機 (CMM)
              </Typography>
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={12} sm={6} md={4} sx={{ mb: 3 }}>
          <Card className="card-list-instru h-100">
            <div className="list-instru_inner">
              <Image
                loading="lazy"
                src={I10}
                alt="ゼニヤタイランド"
                className="card-img"
                width={300}
              />
            </div>
            <CardContent className="list-instru-text">
              <Typography gutterBottom component="h5">
                印刷工程
              </Typography>
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    </div>
  );
}
export default ListImage;
